import React from 'react';

interface Props {
  checked: boolean;
}
const CheckboxIcon = ({ checked }: Props) => {
  if (checked) {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <rect width='24' height='24' rx='4' fill='#FD7E14' />
        <path
          d='M17 9L10.125 16L7 12.8182'
          stroke='white'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  }
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <rect width='24' height='24' rx='4' fill='#EDEFF0' />
      <path d='M17 9L10.125 16L7 12.8182' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default CheckboxIcon;
